import React from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import { handleDeleteDialogClose } from '../../../../../common/properties/formFunctions';

class DeleteDialog extends React.Component {
  deleteProperty = (e) => {
    const { component, propertyId, numberOfImages, deletePropertyWithImages } = this.props;
    e.preventDefault();
    handleDeleteDialogClose(component);
    deletePropertyWithImages(propertyId, numberOfImages);
  }

  render() {
    const { component, confirmDelete } = this.props;

    const deletePropertyActions = [
      <FlatButton
        label="Hætta við" labelStyle={{ color: '#222222' }}
        onTouchTap={() => handleDeleteDialogClose(component)}
      />,
      <FlatButton
        label="Eyða" labelStyle={{ color: '#f53957' }}
        onTouchTap={this.deleteProperty}
      />,
    ];

    return (
      <Dialog
        title="Eyða eign" actions={deletePropertyActions}
        modal={false} open={confirmDelete}
        onRequestClose={() => handleDeleteDialogClose(component)}
      >
        Ertu viss um að þú viljir eyða þessari eign? <br /> <br />
        Um leið og eign er eytt þá er ekki hægt að nálgast hana aftur.
      </Dialog>
    );
  }
}

DeleteDialog.propTypes = {
  component: React.PropTypes.any.isRequired,
  propertyId: React.PropTypes.string.isRequired,
  numberOfImages: React.PropTypes.number.isRequired,
  confirmDelete: React.PropTypes.bool.isRequired,
  deletePropertyWithImages: React.PropTypes.func.isRequired,
};

export default DeleteDialog;



// WEBPACK FOOTER //
// ./src/browser/app/components/Dialogs/DeleteDialog/DeleteDialog.js